import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import {AvatarSize, AvatarShape} from './AvatarConstants';

const DEFAULT_AVATAR_SHAPE = AvatarShape.CIRCLE;

interface AvatarTextProps {
  text: string;
  backgroundColor: string;
  className?: string;
  size: AvatarSize;
  shape: AvatarShape;
}

/**
 * A text-only avatar with text over a circle with a background color.
 */
const AvatarText = ({
  text,
  backgroundColor,
  className,
  size,
  shape = DEFAULT_AVATAR_SHAPE,
}: AvatarTextProps): JSX.Element => (
  <span
    translate="no"
    className={classNames(`avatar avatar--text avatar--${size} avatar--${shape}`, className)}
    style={{backgroundColor}}
  >
    {text}
  </span>
);

AvatarText.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['xxs', 'xs', 'small', 'newsmall', 'large', 'xl']).isRequired,
  shape: PropTypes.oneOf(['circle', 'square']).isRequired,
  text: PropTypes.string.isRequired,
};

AvatarText.defaultProps = {shape: DEFAULT_AVATAR_SHAPE};

export default AvatarText;
